import LanguagePicker from "./LanguagePicker";

export default function SessionPreferences() {
  return <LanguagePicker />;
}
